import { Pipe, PipeTransform } from '@angular/core'

import { marked } from 'marked'

/**
 * LLM 出力の Markdown を HTML 文字列に変換する pure pipe。
 * サニタイズは [innerHTML] バインディング側の Angular 組み込みサニタイザが行うため、
 * bypassSecurityTrustHtml と組み合わせないこと。
 */
@Pipe({
  name: 'markdown',
  standalone: true,
  pure: true,
})
export class MarkdownPipe implements PipeTransform {
  /** Markdown を HTML 文字列へ変換する。空の場合は空文字を返す。 */
  transform(markdown?: string | null): string {
    if (!markdown) return ''
    return marked(markdown) as string
  }
}
